import { FieldList } from '../FieldList/FieldList';

interface Props {
  workHistories: Array<{
    companyName: string;
    roleTitle: string;
    duration?: string;
    achievements?: string;
  }>;
}

export const CareerHistory = ({ workHistories }: Props) => (
  <FieldList
    icon="workExperience"
    iconTone="brandAccent"
    descriptionSize="smallMobile"
    fields={
      workHistories
        ? workHistories.map(
            ({ companyName, roleTitle, duration, achievements }) => ({
              heading: roleTitle,
              subHeading: companyName,
              subHeadingSecondary: duration,
              description: achievements,
            }),
          )
        : []
    }
  />
);
